import React from "react";
import { Stepper, Step, StepLabel, Button, Box } from "@mui/material";
import { useTranslation } from "react-i18next";

function ProgressStepper({ steps, activeStep, onNext, onBack, stepsContent }) {
  const { t } = useTranslation(["common"]);
  return (
    <Box sx={{ width: "100%", padding: "20px" }}>
      <div data-tour="stepper">
      <Stepper activeStep={activeStep} alternativeLabel>
        {steps.map((label, index) => (
          <Step key={index}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
      </div>

      <Box sx={{ marginTop: "20px", padding: "20px", border: "1px solid #ccc", borderRadius: "5px" }}>
        {stepsContent[activeStep]}
      </Box>

      <Box sx={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
        <Button disabled={activeStep === 0} onClick={onBack}>
          {t("common:buttons.back")}
        </Button>
        <Button
          data-tour="next-button"
          variant="contained"
          onClick={onNext}
          sx={{ marginLeft: "10px" }}
          disabled={activeStep === steps.length - 1}
        >
          {t("common:buttons.next")}
        </Button>
      </Box>
    </Box>
  );
}

export default ProgressStepper;
